import { IDeleteDisciplinaChecklistUseCase } from "../../../presentation/useCases/delete/delete_disciplina_checklist";
import { IProjetosRepository } from "../../repositories/projetos_repository";

export class DeleteDisciplinaChecklistUseCase implements IDeleteDisciplinaChecklistUseCase {
  constructor(private readonly repository: IProjetosRepository) {}

  async deleteDisciplinaChecklist(IdDisciplinaChecklist: number): Promise<void> {
    await this.repository.deleteDisciplinaChecklist(IdDisciplinaChecklist);
  }
}
